<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id=center>
    <div style="height: 15%;width: 100%">

      <mt-header title="签署文件">
          <mt-button @click="goback" slot="left"   icon="back">返回</mt-button>
          <mt-button @click="next" slot="right">下一步</mt-button>
      </mt-header>


      <div class="file">
        <mt-field label="文件名称" placeholder="请输入文件名称" v-model="filename"/>
      </div>
    </div>
    <div id="uploadfile1" class="uploadfile" v-show="uploadfile1ShowStatus">
      <div class="addFileTitle">添加文件</div>
      <div class="addFile">
        <img v-on:click="uploadFile" class="addImg" src="/static/img/sign/uploadFile/add.png"/>
      </div>
      <hr style="width: 96%;margin-top: 2rem">
      <div class="document">
        <h5>提示：</h5>
        <p>1.由于各手机浏览器支持功能不同，若您是安卓手机建议用<b>QQ浏览器</b>进行签署，若是苹果手机建议您使用苹果自带浏览器<b>Safari浏览器</b>进行签署。</p>
        <p>2.系统支持 <b>doc/docx/pdf/xlsx/xls/ppt/pptx/jpg/png/txt</b> 格式文件(若上传excel文件和txt文件,请确保内容不超过A4纸张)。</p>
        <p>3.单文件上传大小建议 <b>10M</b> 以内。</p>
        <!-- <p>*系统支持doc/docx/pdf/xlsx/xls/ppt/pptx/jpg/png/txt格式文件(若上传excel文件和txt文件,请确保内容不超过A4纸张),单文件大小10M以内;
        </p> -->
      </div>
    </div>

    <div id="uploadfile2" class="uploadfile" v-show="uploadfile2ShowStatus">
      <div class="addFileTitle">添加文件</div>
      <div class="deleteUpload" @click="deleteUploadFile"><img src="/static/img/sign/uploadFile/delete.png"></div>
      <div style="width: 12rem">
        <img class="uploadFileDoneImg" src="/static/img/sign/uploadFile/file.png"/>
        <div class="uploadFileName">{{filename}}</div>
      </div>
      <hr style="width: 96%;margin-top: 2rem">
      <div class="document">
        <h5>提示：</h5>
        <p>1.由于各手机浏览器支持功能不同，若您是安卓手机建议用<b>QQ浏览器</b>进行签署，若是苹果手机建议您使用苹果自带浏览器<b>Safari浏览器</b>进行签署。</p>
        <p>2.系统支持 <b>doc/docx/pdf/xlsx/xls/ppt/pptx/jpg/png/txt</b> 格式文件(若上传excel文件和txt文件,请确保内容不超过A4纸张)。</p>
        <p>3.单文件上传大小建议 <b>10M</b> 以内。</p>
        <!-- <span>*系统支持doc/docx/pdf/xlsx/xls/ppt/pptx/jpg/png/txt格式文件(若上传excel文件和txt文件,请确保内容不超过A4纸张),单文件大小10M以内;
        </span> -->
      </div>
    </div>
    <form>

    </form>
    <input name="uploadFile" style="display: none" id="uploadFile" type="file" @change="onFileChange()"/>
  </div>
</template>
<script>
  import {Toast, Actionsheet, Field, Indicator,MessageBox} from 'mint-ui';
  import cheader from '@/components/header';
  var count = 5;
  var outTimer;
  var contractFile;
  var interval = null;
  export default {
    name: 'uploadFile',
    data () {
      return {
        fileSize: 0,
        filename: '',
        uploadFileDoneImg: '',
        uploadfile1ShowStatus: true,
        uploadfile2ShowStatus: false,
        fileType: '',
        routerName: {}
      }
    },

    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      getParams(){
        let params = this.$route.query;
        this.fileType = params.fileType;
        this.routerName = params._router;
      },

      next: function () {
        if (this.filename == null || this.filename == '' || typeof(this.filename)=="undefined"){
          Toast("文件名称不可以为空");
          return;
        }
        
        if (contractFile != null) {
          var that = this;
          //保活
          interval = setInterval(function() {
              that.$http.post(domain("_isme")).then((res) => {
                  console.log('正在保活')
              }).catch((e) => {
                  console.log(e)
              });
          }, 60000);
          var _uploadContract_url = domain("_uploadContract");
          var formData = new FormData();
          formData.append("contractFile",contractFile);
          formData.append("contractName",this.filename)
          formData.append("fileType",this.fileType);
          that.$http.post(
            _uploadContract_url,
            formData,
            {emulateJSON: true,
              headers:{
                "Content-Type": "multipart/form-data"
              }}
            )
            .then(function (response) {  //接口返回数据
              var code = response.data.code;
              clearInterval(interval);
                  //跳转到合同签署页面
              if(code == '0'){
                this.$router.push({
                  path: '/contract/sign',
                  name: 'sign',
                  query: {'cid': response.data.data.contractId}
                })
              }else if(code == '5'){
                 MessageBox.confirm('', { 
                 message: '套餐余额不足，请先购买套餐后进行签署！', 
                 title: '提示', 
                 confirmButtonText: '去购买', 
                 cancelButtonText: '取消' 
                 }).then(action => { 
                   if (action == 'confirm') {
                    that.$router.push("/combo/buyCombo");
                   }
                 }).catch(err => { 
                   if (err == 'cancel') {
                    console.log('取消');
                   } 
                 });
              } else {
                var msg = response.data.msg;
                this.$toast(msg);
              }
            }, function (error) {
              //Toast("数据获取响应异常.")
              clearInterval(interval);
            }).catch(function (response) {
            //Toast("数据获取响应异常.")
            clearInterval(interval);
            Indicator.close();
          })
        } else {
          Toast("请添加文件");
        }
      },
      deleteUploadFile: function () {
        this.uploadfile1ShowStatus = true;
        this.uploadfile2ShowStatus = false;
        contractFile = null;
        this.filename = '';
      },
      uploadFile: function () {
        uploadFile.click();
      },
      settime: function () {
        var that = this;
        if (count == 0) {
          Indicator.close();
          window.clearTimeout(1000);
          window.clearInterval(1000)
        }
        count--;
        console.log(count);
        outTimer = setTimeout(function () {
          that.settime()
        }, 1000);
      },
      onFileChange(e) {
//        var files = e.target.files || e.dataTransfer.files;
        var files =  document.getElementById("uploadFile").files;
        if (!files.length)
          return;
        contractFile = files[0];
        var name=this.filename;
        var fname = contractFile.name;
        if(this.filename == ""){
        name = fname;
        }
        var extStart = fname.lastIndexOf(".");
        var ext = fname.substring(extStart, contractFile.length).toLowerCase();
//        var formData = new FormData();
//        formData.append('file', file);
        if (ext != ".pdf" && ext != ".doc" && ext != ".docx" && ext != ".ppt" && ext != ".xls"
          && ext != ".pptx" && ext != ".xlsx" && ext != ".jpg" && ext != ".txt"
          && ext != ".png" && ext != ".jpeg") {
          Toast("文件格式不正确！" + ext);
          return;
        }
        this.filename = name;
        this.uploadfile1ShowStatus = false;
        this.uploadfile2ShowStatus = true;
        var _input = $('#uploadFile');
        _input.val('');
      }

    },
    watch: {
      // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
      '$route': 'getParams'
    },
    components: {
      cheader
    },
    mounted: function () {
      this.getParams();
    }
  }
</script>
<style>
  #center {
    width: 100%;
    height: 100%;
    background-color: #ECECEC;
  }

  /*.title {*/
    /*width: 100%;*/
    /*height: 3.5rem;*/
    /*background-color: #1f74d8;*/
    /*color: #ffffff;*/
    /*font-family: "Microsoft YaHei";*/
    /*font-size: 1.2rem;*/
    /*line-height: 3.5rem;*/
  /*}*/

  /*.title .left {*/
    /*width: 20%;*/
    /*display: inline;*/
    /*float: left;*/
  /*}*/

  /*.title .left span {*/
    /*margin-left: 1rem;*/
  /*}*/

  /*.title .mid {*/
    /*width: 60%;*/
    /*text-align: center;*/
    /*float: left;*/
  /*}*/

  /*.title .right {*/
    /*width: 20%;*/
    /*text-align: center;*/
    /*float: left;*/
    /*font-size: 1rem;*/
  /*}*/

  /*.title .right span {*/
    /*margin-right: 1rem;*/
  /*}*/



  .file {
    width: 100%;
    line-height: 4rem;
    color: #7d7d7d;
    font-family: "Microsoft YaHei";
    font-size: 2rem;
  }

  .uploadfile {
    height: 82.5%;
    background-color: #ffffff;
    margin-top: 0.5%;
    padding-left: 0.7rem;
    padding-right: 0.7rem;
    padding-top: 1rem;
  }

  .addFileTitle {
    font-size: 0.9rem;
    color: #7d7d7d;
    font-family: "Microsoft YaHei";
  }

  .addFile {
    margin-top: 1rem;
    display: block;
    width: 12rem;
    height: 12rem;
    border-color: rgba(215, 215, 215, 1);
    background-color: #f0f0f0;
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
  }

  .addImg {
    display: block;
    width: 4rem;
    height: 4rem;
    margin: 0 auto;
    margin-top: 4rem;
  }

  .document {
    word-break: break-all;
    display: block;
    width: 96%;
    margin-top: 1rem;
    font-size: 1rem;
    color: #c1c1c1;
    font-family: "Microsoft YaHei";
  }
  .document h5{
    font-size: 12px;
    font-weight: 600;
    color:#26a2ff;
  }
  .document p{
    margin-bottom:5px;
  }
  .document b{
    color:red;
    font-weight: 500;
  }
  .uploadFileDoneImg {
    display: inherit;
    width: 12rem;
    height: 12rem;
  }

  .uploadFileName {
    border-color: rgba(215, 215, 215, 1);
    background-color: #f0f0f0;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    font-size: 1rem;
    color: #c1c1c1;
    line-height: 1.8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .deleteUpload {
    position: relative;
    left: 11rem;
    top: 0.5rem;
    width: 22px;
    height: 22px;
  }
  .document p,.document span{
    font-size: 0.7rem;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/module/sign/uploadFile.vue